import { createErrorStore } from "../../error";
import { FieldKey } from "../shared/types";
import { SignupFlowSlug } from "../constants";

/**
 * Zustand store for tracking validation errors and validated fields.
 */
export const useSignupFlowErrorStore = createErrorStore<FieldKey, SignupFlowSlug>(
  "suf-error-store",
);
